export {sortEmployment, sortEarnings};


function sortEmployment(a, b) {
    return parseInt(a.year) - parseInt(b.year);
}
function sortEarnings(a, b) {
    return parseInt(a.percentile) - parseInt(b.percentile);
}
function sortEducation(a, b){
    let order = ["a high school diploma or less","a certificate","some college","an Associate degree","a Bachelor's degree","a Master's or Professional degree","a Doctoral degree or more"]

}